import React, { createContext, useContext, useState, useEffect } from 'react'
import { fetchData } from '../../Assets/API/apiservices'
import moment from 'moment'
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from '../../Config/Config'

const ActivityContext = createContext()

export const ActivityProvider = ({ children }) => {
  const [activitiesData, setActivitiesData] = useState([])
  const [yearsData, setYearsData] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const {
          rows: [{ id: dynamicId }],
        } = await fetchData(
          `webpages?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
        )
        const activities = await fetchData(
          `webpages/${dynamicId}?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
        )

        setActivitiesData(activities)
        setYearsData([
          ...new Set(activities.map((item) => moment(item.date).year())),
        ])
      } catch (error) {
        console.error('Error fetching activities:', error)
      }
    })()
  }, [])

  return (
    <ActivityContext.Provider
      value={{ activitiesData, yearsData, setActivitiesData }}
    >
      {children}
    </ActivityContext.Provider>
  )
}

export const useActivity = () => useContext(ActivityContext)
